import {
  FormInput,
  FormInputProps,
} from '@moneyforward/ap-frontend-components';
import { memo } from 'react';
import { FieldValues } from 'react-hook-form';
import { CellProps } from './type';

export type Props<TFieldValues extends FieldValues> =
  {} & FormInputProps<TFieldValues> & CellProps;

const InnerFormInputCell = <TFieldValues extends FieldValues>({
  control,
  name,
  ...rest
}: Props<TFieldValues>) => {
  return <FormInput<TFieldValues> control={control} name={name} {...rest} />;
};
InnerFormInputCell.displayName = 'FormInputCell';

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export const FormInputCell = memo(
  InnerFormInputCell
) as typeof InnerFormInputCell;
